import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Layout from "@/components/portfolio/Layout";
import Home from "@/pages/Home";
import Work from "@/pages/Work";
import About from "@/pages/About";
import ComingSoon from "@/pages/ComingSoon";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Work />} />
            <Route path="/projects/stockmate" element={<ComingSoon />} />
            <Route path="/projects/ai-website-builder" element={<ComingSoon />} />
            <Route path="/projects/storepilot" element={<ComingSoon />} />
            <Route path="/projects/:id" element={<ComingSoon />} />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
